import {jailFocus, unJailFocus} from '@kuik/modules/jailfocus.js';

// CONSTANTS
const TOGGLE_EVENT = 'toggle';

const DIV_TAG = 'div';

const BACKDROP_CLASS = 'panel-backdrop';
const POPOVER_OPEN_CLASS = 'panel--open';

const PANEL_MODAL_SELECTOR = '.panel--modal';
const BACKDROP_SELECTOR = `.${BACKDROP_CLASS}`;
const OPENED_PANELS_SELECTOR = `${PANEL_MODAL_SELECTOR}.${POPOVER_OPEN_CLASS}`;
const POPOVER_STATE_OPEN = 'open';

/**
 * Événement exécuté à l'ouverture ou la fermeture du panneau.
 */
function panelToggleHandler(event) {
    const {target} = event;
    target.classList.toggle(POPOVER_OPEN_CLASS, event.newState === POPOVER_STATE_OPEN);
    const openedPanels = document.querySelectorAll(OPENED_PANELS_SELECTOR);
    const currentBackdrop = document.querySelector(BACKDROP_SELECTOR);
    if (openedPanels.length && !currentBackdrop) {
        const backdrop = document.createElement(DIV_TAG);
        backdrop.classList.add(BACKDROP_CLASS);
        document.body.appendChild(backdrop);
    } else if (!(openedPanels.length) && currentBackdrop) {
        currentBackdrop.remove();
    }
    if (event.newState === POPOVER_STATE_OPEN) {
        jailFocus(target);
        const autofocus = target.querySelector('[autofocus]');
        if (autofocus) {
            autofocus.focus();
        }
    } else {
        unJailFocus(target);
    }
}

/**
 * Ajoute les contrôles d'événements nécessaires au fonctionnement modal du panneau.
 * @param {HTMLElement} panel Panneau concerné
 */
function bindModalPanelEvents(panel) {
    panel.addEventListener(TOGGLE_EVENT, panelToggleHandler);
}

/**
 * Retire les contrôles d'événement nécessaires au fonctionnement modal du panneau.
 * @param {HTMLElement} panel Panneau concerné
 */
function unbindModalPanelEvents(panel) {
    panel.removeEventListener(TOGGLE_EVENT, panelToggleHandler);
}

/**
 * Initialise un panneau modal.
 * @param {HTMLElement} panel Panneau à initialiser
 */
function initModalPanel(panel) {
    bindModalPanelEvents(panel);
}

/**
 * Détruit la gestion associée à un panneau modal.
 * @param {HTMLElement} panel Panneau concerné
 */
function destroyModalPanel(panel) {
    unbindModalPanelEvents(panel);
}

/**
 * Initialise tous les panneaux modaux trouvés sur la page.
 */
function initAllModalPanel() {
    document.querySelectorAll(PANEL_MODAL_SELECTOR).forEach(initModalPanel);
}

/**
 * Détruit la gestion associée à tous les panneaux modaux trouvés sur la page.
 */
function destroyAllModalPanel() {
    document.querySelectorAll(PANEL_MODAL_SELECTOR).forEach(destroyModalPanel);
}

export { initAllModalPanel, initModalPanel, destroyAllModalPanel, destroyModalPanel };

window.addEventListener('load', initAllModalPanel);

const body = document.querySelector('body');
const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.target.querySelectorAll(PANEL_MODAL_SELECTOR).forEach((panel) => {
            destroyModalPanel(panel);
            initModalPanel(panel);
        });
    });
});
mutationObserver.observe(body, {childList: true, subtree: true, attributes: false});
